import Service from "../../AuthService";
const ImportProducts = {
    getImportProducts(page) {
        return Service.get("/import-product?page="+page);
    },
    showImportProducts(id) {
        return Service.get("/import-product/" + id);
    },
    updateImportProducts(id, data) {
        return Service.put("/import-product/" + id, data);
    },
    createImportProducts(data) {
        return Service.post("/import-product", data);
    },
    deleteImportProducts(id) {
        return Service.delete("/import-product/" + id);
    },
    searchImportProducts(page,code,date_start , date_end,type_id) {
        return Service.post(
            "/search-import-product?page="+ page +"&code=" + code + "&date_start=" + date_start + "&date_end=" + date_end + "&type_id=" + type_id
        );
    }
};
export default ImportProducts;
